import { render, staticRenderFns } from "./DiscussAnswerItem.vue?vue&type=template&id=4c61d622&scoped=true&"
import script from "./DiscussAnswerItem.vue?vue&type=script&lang=ts&"
export * from "./DiscussAnswerItem.vue?vue&type=script&lang=ts&"
import style0 from "./DiscussAnswerItem.vue?vue&type=style&index=0&id=4c61d622&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c61d622",
  null
  
)

export default component.exports